import { ContainingAppPlatform, getContainingApp, isLegacyGooglePlayAppUserAgent } from './containing_app.ts';

export enum Device {
  iOS = 'ios',
  Android = 'android',
  Other = 'other',
}

export enum Platform {
  Mobile = 'mobile',
  Desktop = 'desktop',
}

export function getDevice(): Device {
  // Store apps 24.0 and later say which platform they are (the stock iPad user agent claims to be a Mac)
  const containingApp = getContainingApp();
  if (containingApp) {
    return containingApp.platform === ContainingAppPlatform.Android ? Device.Android : Device.iOS;
  }
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
    return Device.iOS;
  } else if (userAgent.includes('android') || isLegacyGooglePlayAppUserAgent(userAgent)) {
    // TODO(remove after 2027-10-13): Google Play app versions 23 and earlier sent the bare user
    // agent "Sing Your Part"; see isLegacyGooglePlayAppUserAgent
    return Device.Android;
  }
  return Device.Other;
}

export function isIPhone() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.includes('iphone');
}

export function getPlatform(): Platform {
  return getDevice() === Device.Other ? Platform.Desktop : Platform.Mobile;
}

export const iOSVersion =
  typeof window !== 'undefined' &&
  typeof window.navigator !== 'undefined' &&
  (parseFloat(
    ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1])
      .replace('undefined', '3_2')
      .replace('_', '.')
      .replace('_', ''),
  ) ||
    false);
